import React, { useContext } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Accordion, AccordionItem, List } from '@sm/wds-react';
import { SubMenuItem } from '../components/SubMenuItem';

import userDropDownQuery from '../../../components/UserDropDown/UserDropDown.graphql';
import SMHeaderContext from '../../../SMHeaderContext.js';

import {
  myAccount,
  signOut,
  team,
  library,
  contacts,
  benchmark,
  switchAccount,
} from '../../../config/MobileLinkInfo.js';

export const UserDataMenu = () => {
  const { lang, isEUDC } = useContext(SMHeaderContext);
  const { loading, error, data } = useQuery(userDropDownQuery, {});
  if (loading) return null;
  if (error) {
    const username = 'My Account';
    return (
      <Accordion className="sm-mobile-menu-auth__li-accordionitem">
        <AccordionItem title={username}>
          <List transparent>
            <SubMenuItem {...myAccount()} />
            <SubMenuItem {...signOut()} />
          </List>
        </AccordionItem>
      </Accordion>
    );
  }

  const { username, preferences, features, linkedIdentities } = data.user;
  const teamMembership = data.user.teamMembership || {};
  const isTeamOwner = teamMembership.memberType === 'ACCOUNT_OWNER';
  const isEnterpriseAccount = teamMembership.isEnterprise;
  const isNonEnterpriseGroupAdmin = !isEnterpriseAccount && isTeamOwner;
  const { paidBenchmarksEnabled } = preferences;
  const liteLibraryEnabled = features && features.liteLibraryEnabled;
  const plansBenchmarksEnabled = features && features.plansBenchmarksEnabled;
  const libraryEnabled = teamMembership || liteLibraryEnabled;
  const hasMultipleLinkedIdentities = linkedIdentities.totalCount > 1;

  return (
    <Accordion className="sm-mobile-menu-auth__li-accordionitem">
      <AccordionItem title={username}>
        <List transparent>
          <SubMenuItem {...myAccount()} />
          {hasMultipleLinkedIdentities ? (
            <SubMenuItem {...switchAccount()} />
          ) : null}
          {isNonEnterpriseGroupAdmin ? <SubMenuItem {...team()} /> : null}
          {!isEnterpriseAccount && libraryEnabled ? (
            <SubMenuItem {...library()} />
          ) : null}
          <SubMenuItem {...contacts()} />
          {((lang === 'en' && plansBenchmarksEnabled) ||
            paidBenchmarksEnabled) &&
          !isEUDC ? (
            <SubMenuItem {...benchmark()} />
          ) : null}
          <SubMenuItem {...signOut()} />
        </List>
      </AccordionItem>
    </Accordion>
  );
};

export default UserDataMenu;
